<template>
  <div style="background-color: #f5f5f5;">
    <Topo />
    <b-container>
      <h3 class="mb-4 text-center"><b><u>Alteração da Senha de Acesso</u></b></h3>
      <div class="row">
        <div class="col-md-3 mb-3">
          <Menu />
        </div>
        <div class="col-md-9">
          <b-card header-tag="header">
            <h5 slot="header" class="mb-0"><b>Preencha os dados abaixo para alterar sua senha</b></h5>
            <b-card-text>
              <b-form class="form" @submit="onSubmit">
                <div class="row">
                  <div class="col-md-4">
                    <b-form-group label="Senha Atual" label-for="senha_atual">
                      <b-form-input id="senha_atual" v-model="senha_atual" type="password" max-lenght="20" size="sm" required></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group label="Nova Senha" label-for="nova_senha">
                      <b-form-input id="nova_senha" v-model="senha" type="password" max-lenght="20" size="sm" required></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group label="Redigitação de senha" label-for="redigitacao">
                      <b-form-input id="redigitacao" v-model="redigitacao" type="password" max-lenght="20" size="sm" required></b-form-input>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group label="Lembrete de senha" label-for="lembrete">
                      <b-form-input id="lembrete" v-model="lembrete" max-lenght="50" size="sm" required></b-form-input>
                    </b-form-group>
                  </div>
                </div>
                <div class="row" style="margin-top: 16px;">
                  <div class="col-md-12">
                    <b-button v-if="!trabalhando" type="submit" variant="success"><i class="fa fa-check mr-2" aria-hidden="true"></i>Alterar Senha</b-button>
                    <b-button v-else variant="primary" disabled>
                      <b-spinner small></b-spinner>
                      Alterando...
                    </b-button>
                  </div>
                </div>
              </b-form>
            </b-card-text>
          </b-card>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>

import { baseApiUrl, showError } from '@/global'
import { mapState } from 'vuex'
import axios from 'axios'
import Topo from '@/components/Topo.vue'
import Menu from '@/components/Menu.vue'

export default {
  name: 'AlterarSenha',
  computed: mapState(['user']),
  components: { Topo, Menu },
  data: function () {
    return {
      trabalhando: false,
      senha_atual: '',
      senha: '',
      redigite: '',
      lembrete: ''
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      if (this.senha !== this.redigitacao) return showError('Redigitação da senha não confere!')
      const dados = {
        senha_atual: this.senha_atual,
        senha: this.senha,
        lembrete: this.lembrete
      }
      const url = `${baseApiUrl}/ficha/altera_senha/${this.user.id}`
      axios.put(url, dados)
        .then(() => {
          this.$toasted.global.defaultSuccess({ msg: 'Senha de acesso alterada com sucesso!' })
        })
        .catch(err => { showError(err) })
    }
  }
}
</script>
